module.exports = __webpack_public_path__ + "img/1spade-10.9232edce.svg";